import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom';
import feather from 'feather-icons';
import ApiRequest from '../Common/restservice';
import { errorToast } from '../Common/showtoast';
function ProfileModal({ showProfile, setShowProfile }) {
  const navigate = useNavigate();
  useEffect(() => {
    feather.replace();
  }, [showProfile])

  return (
    <Modal className='modal-right fade' show={showProfile} onHide={() => {
      setShowProfile(false);
    }} >
      <Modal.Dialog contentClassName='slim-scroll3'>
        <Modal.Body className='p-30 bg-white'>
          <div className="d-flex align-items-center mb-15 justify-content-between pb-30">
            <h4 className="m-0">Profile</h4>
            <a href="#" onClick={(e) => {
              e.preventDefault();
              setShowProfile(false);
            }} className="btn btn-icon btn-danger-light btn-sm no-shadow" data-bs-dismiss="modal">
              <span className="fa fa-close"></span>
            </a>
          </div>
          <div>
            <div className="d-flex align-items-center mb-30">
              <div className="me-15 bg-primary-light h-50 w-50 l-h-60 rounded justify-content-center d-flex align-items-center">
                <i data-feather="user" />
              </div>
              <div className="d-flex flex-column fw-500">
                <Link to={"/profile"} className="text-dark hover-primary mb-1 fs-16" onClick={() => setShowProfile(false)}>My Profile</Link>
                <span className="text-fade">Edit profile</span>
              </div>
            </div>
            <div className="d-flex align-items-center mb-30">
              <div className="me-15 bg-info-light h-50 w-50 l-h-60 rounded justify-content-center d-flex align-items-center">
                <i data-feather="shield" />
              </div>
              <div className="d-flex flex-column fw-500">
                <Link to={"/kyc"} className="text-dark hover-info mb-1 fs-16" onClick={() => setShowProfile(false)}>KYC</Link>
                <span className="text-fade">Verify your identity</span>
              </div>
            </div>
            <div className="d-flex align-items-center mb-30">
              <div className="me-15 bg-success-light h-50 w-50 l-h-60 rounded justify-content-center d-flex align-items-center">
                <i data-feather="settings" />
              </div>
              <div className="d-flex flex-column fw-500">
                <Link to={"/settings"} className="text-dark hover-success mb-1 fs-16" onClick={() => setShowProfile(false)}>Settings</Link>
                <span className="text-fade">Change password</span>
              </div>
            </div>
            <div className="d-flex align-items-center mb-30">
              <div className="me-15 bg-danger-light h-50 w-50 l-h-60 rounded justify-content-center d-flex align-items-center">
                <i data-feather="log-out" />
              </div>
              <div className="d-flex flex-column fw-500">
                <label className="text-dark hover-danger mb-1 fs-16" onClick={() => {
                  setShowProfile(false);
                  localStorage.clear();
                  navigate("/");
                }}>Logout</label>
                <span className="text-fade">Exit from panel</span>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal.Dialog>
      {/* <div className="modal modal-right fade" id="quick_user_toggle" tabindex="-1">
      <div className="modal-dialog">
        <div className="modal-content slim-scroll3">
          <div className="modal-body p-30 bg-white">
            
          </div>
        </div>
      </div>
    </div> */}
    </Modal>
  )
}

export default ProfileModal